// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  firebase: {
    apiKey: "AIzaSyDCOhzrZeSeqCBwXFLNK9vHmJIDvfbQBQk",
    authDomain: "toro-investimentos-hub.firebaseapp.com",
    projectId: "toro-investimentos-hub",
    storageBucket: "toro-investimentos-hub.appspot.com",
    messagingSenderId: "570353680997",
    appId: "1:570353680997:web:6f0cafbab5ff05272afc8c"
  },
  isNewBrand: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
